import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const dayNames = ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];

export const Day = props => {
    const day = moment(props.day);

    const style = {
        width: props.size + '%'
    };
    let className;
    const weekDay = day.day();
    if(moment().isSame(day, 'date')){
        className= 'dd-day today';
    }
    else if(weekDay === 6 || weekDay === 0){
        className= 'dd-day weekend';
    }
    else{
        className = 'dd-day'
    }

    return (
        <div className={className} key={day.toISOString()} style={style} onClick={() => {props.onClick(day)}}>
            <div>{dayNames[weekDay]}</div>
            <div>{day.date()}</div>
        </div>
    );
};
Day.propTypes = {
    day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    size: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
};



export const EmptyDay = props => {
    return (
        <div className={`dd-cell empty${props.highlight ? ' hightlight' : ''}`} style={{width: props.size+'%'}}/>
    );
};
EmptyDay.propTypes = {
    size: PropTypes.number.isRequired,
    highlight: PropTypes.bool.isRequired
};

export const ColorDay = props => {
    const day = moment(props.day);

    let style = {width: props.size+'%'};
    if(props.pct === 100){
        style = {
            ...style,
            background: props.hexColor
        }
    }
    else if(props.fromLeft){
        style = {
            ...style,
            background: `linear-gradient(90deg, rgba(255,255,255,0.3) ${props.pct}%, ${props.hexColor} ${props.pct}%)`
        }

    }
    else{
        style = {
            ...style,
            background: `linear-gradient(90deg, ${props.hexColor} ${props.pct}% , rgba(255,255,255,0.3) ${props.pct}%)`
        }
    }

    return (
        <div className={`dd-cell${props.highlight ? ' hightlight' : ''}`} key={day.toISOString()} style={style}/>
    );
};
ColorDay.propTypes = {
    day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    size: PropTypes.number.isRequired,
    highlight: PropTypes.bool.isRequired,
    hexColor: PropTypes.string.isRequired,
    pct: PropTypes.number.isRequired,
    fromLeft: PropTypes.bool.isRequired
};
